import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import { forwardRef, useState } from "react";

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
const PreviewSegmentCard = forwardRef(
  (
    {
      imgurl,
      maxViewSize,
      handleSaveSegmentedImage,
      imgHeight,
      imgWidth,
      scale = 1,
      setWaiting,
    },
    ref
  ) => {
    const [detailVisible, setDetailVisible] = useState(false);
    const width = imgWidth * scale;
    const height = imgHeight * scale;
    return (
      <div style={{ height: "100%", width: "auto", overflow: "hidden" }}>
        <div style={{ display: "flex", justifyContent: "center", height: "100%", width: "auto" }}>
          <div
            style={{
              textAlign: "center",
              position: "relative",
              maxWidth: "100%",
              height: "100%",
              width: "auto",
              background: `repeating-conic-gradient(
                  #fff 0 90deg,
                  #e3e3e3 0 180deg) 
              0 0/5% 5%`,
            }}
            className="hover-parent-1"
          >
            {imgurl ? (
              <img
                src={imgurl}
                alt={"prev_image"}
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: maxViewSize,
                  maxWidth: maxViewSize,
                  cursor: "pointer",
                }}
                onClick={() => setDetailVisible(true)}
              />
            ) : (
              <div />
            )}

            {imgurl ? (
              <div
                className="overlay-1"
                style={{
                  textAlign: "center",
                  width: "100%",
                  zIndex: 2,
                }}
              >
                <SuiButton
                  variant="contained"
                  color="white"
                  size="small"
                  sx={{
                    whiteSpace: "nowrap",
                    textTransform: "capitalize",
                    width: "100%",
                    mb: 1,
                  }}
                  onClick={async () => handleSaveSegmentedImage(imgurl)}
                >
                  Save the segment
                </SuiButton>
              </div>
            ) : null}
          </div>
        </div>

        <Lightbox
          open={detailVisible}
          close={() => setDetailVisible(false)}
          slides={[{ src: imgurl }]}
          plugins={[Zoom, Download]}
          zoom={{ maxZoomPixelRatio: 3 }}
          index={0}
        />
      </div>
    );
  }
);

export default PreviewSegmentCard;
